import { IMG } from "./services";

export const ARTICLES = [
  {
    slug: "كيف-اعرف-ان-الكفر-يحتاج-الي-تغيير",
    title: "كيف أعرف أن الكفر يحتاج إلى تغيير؟",
    excerpt: "خمس علامات واضحة تخبرك أن كفر سيارتك وصل إلى نهاية عمره — من عمق النقشة إلى الشقوق الجانبية والاهتزاز.",
    image: IMG.flat,
    alt: "كفر سيارة متآكل يحتاج إلى تغيير",
    date: "2025-12-18",
    readTime: "4 دقائق",
    sections: [
      {
        h2: "عمق النقشة وصل إلى الحد الأدنى",
        body: "النقشة هي ما يشد الكفر بالطريق ويطرح الماء من تحته في الأيام الممطرة. الحد الأدنى لعمق النقشة هو 1.6 ملم، ومعظم الكفرات الحديثة تحمل علامات تآكل (TWI) بين نقشات الكفر — إذا وصل التآكل إلى هذه العلامات فقد انتهى عمر الكفر فعلياً، مهما بدا شكله جيداً من بعيد. اختبار بسيط: أدخل عملة معدنية في النقشة؛ إذا ظهر معظم جسمها فالعمق قليل جداً.",
      },
      {
        h2: "تشققات وانتفاخات على الجانب",
        body: "افحص جانب الكفر (الجدار الجانبي) بحثاً عن شقوق دقيقة أو خطوط جافة — وهي نتيجة الحرارة والعمر، وهي خطيرة لأنها تضعف بنية الكفر. أما الانتفاخ (فقاعة على الجانب) فهو تحذير فوري: يعني تلفاً داخلياً في خيوط الكفر، غالباً بعد اصطدام بحافة رصيف أو حفرة. الكفر المنتفخ لا يُصلح — يجب تغييره فوراً لأن احتمال انفجاره عالي.",
      },
      {
        h2: "اهتزاز تشعر به في المقود",
        body: "الاهتزاز المستمر بسرعات معينة قد يعني حاجة الكفر للترصيص أو مشكلة في التوازن، لكنه قد يكون أيضاً نتيجة تآكل غير متساوٍ داخل الكفر نفسه (فصل في طبقات الكفر). إذا لم يزل اهتزازك بعد الترصيص والموازنة، فالكفر نفسه هو المشكلة.",
      },
      {
        h2: "عمر الكفر تجاوز الخمس سنوات",
        body: "حتى الكفر غير المستخدم يتقادم: المطاط يفقد مرونته مع الوقت والحرارة. في أجواء الرياض يتسارع هذا التقادم. ابحث عن رمز DOT على جانب الكفر — آخر أربعة أرقام تشير إلى أسبوع وسنة الصناعة (مثلاً 2324 تعني الأسبوع 23 من سنة 2024). الإطارات التي تجاوز عمرها خمس أو ست سنوات، مهما بدت جيدة، يُنصح بتغييرها — خاصة على السيارات التي تسافر بأحمال عالية.",
      },
      {
        h2: "نقص ضغط متكرر دون سبب واضح",
        body: "إذا كنت تعبئ الهواء في الكفر نفسه كل أسبوع، فهناك تسريب صغير أو مشكلة في صمام الهواء أو التلاحم بين الكفر والجنط. بعض الحالات تُصلح (ثقب في منطقة النقشة يمكن إغلاقه)، أما الثقب في الجدار الجانبي أو الكفر الذي فقده بنية الداخل فيجب استبداله. اطلب فحصاً ميدانياً — الفني ينزع الكفر ويفحصه من الداخل ويخبرك: إصلاح أم تغيير.",
      },
    ],
    conclusion: "قاعدة عامة: الجدار الجانبي التالف، والعمر الطويل، والتآكل حتى علامة TWI — ثلاثة مواقف تستوجب التغيير. أما الثقب الصغير في منطقة النقشة فيمكن غالباً إصلاحه في موقعك. عند الشك، أرسل لنا صورة الكفر على واتساب وسنساعدك في اتخاذ القرار الصحيح.",
  },
  {
    slug: "متي-اغير-اطارات-السيارة",
    title: "متى أغير إطارات السيارة؟",
    excerpt: "دليل عملي لتحديد الوقت الصحيح لتغيير إطارات سيارتك: العمق، العمر، الموسم، وحالة القيادة في أجواء الرياض.",
    image: IMG.tread,
    alt: "نقشة إطارات سيارة قديمة تحتاج إلى استبدال",
    date: "2025-12-22",
    readTime: "4 دقائق",
    sections: [
      {
        h2: "عندما يقترب عمق النقشة من الحد الأدنى",
        body: "لا تنتظر أن يصبح الكفر أملس تماماً. الأداء على الطريق المبلل يبدأ بالتدهور قبل أن يصل العمق إلى 1.6 ملم بوقت طويل. إذا كان عمق نقشاتك يقارب 3 ملم، فابدأ التخطيط للتغيير — خاصة قبل موسم الأمطار أو قبل سفر طويل.",
      },
      {
        h2: "عندما يتقدم عمر الإطارات",
        body: "الإطار له تاريخان: عمر الاستخدام وعمر التخزين. كفر تسير به يومياً في الرياض يتحمل حرارة الطريق والوقوف تحت الشمس، وهذا يسرّع شيخوخة المطاط. كقاعدة عامة: راجع إطاراتك بعد خمس سنوات من تاريخ الصناعة، ولا تُطل استخدامها إلى ما بعد ست سنوات حتى لو بدا النقش جيداً.",
      },
      {
        h2: "علامات تآكل غير متساوٍ",
        body: "انظر إلى توزيع التآكل على الكفر: تآكل أكبر على الأطراف يعني سفرةً بضغط منخفض لفترة طويلة، وتآكل في المنتصف يعني ضغطاً زائداً، وتآكل غير متساوٍ بين جوانب الكفر قد يعني مشكلة في زوايا العجلات أو حاجة العجلة للفحص. عالج السبب ثم غيّر الكفر — وإلا فالكفر الجديد سيتآكل بنفس الطريقة.",
      },
      {
        h2: "قبل السفر وعند تغيّر نمط الاستخدام",
        body: "إذا كنت تنوي سفراً طويلاً بحمل عائلي كامل، فهذا ليس الوقت المناسب لكفرات مقتبسة العمر. كذلك إذا تغيّر استخدامك — من مدينة إلى طريق سريع يومي، أو من سيارة فردية إلى عائلية بحمولة أعلى — قد تحتاج إلى كفرات بمؤشر حمولة أعلى.",
      },
      {
        h2: "أغيّر الأربعة أم الاثنين؟",
        body: "الأفضل دائماً تغيير الكفرات الأربعة معاً لضمان توازن التعليق والتماسك. إن كان التغيير اثنين فقط، ركّب الكفرين الجديدين على المحور الخلفي مهما كان نظام الدفع — فهذا يحميك من الانزلاق الخلفي في المنعطفات، وتأكد من قرابة عمر الكفرات القديمة المتبقية إلى الكفرات الجديدة.",
      },
    ],
    conclusion: "ملخص القرار: عمق أقل من 3 ملم = خطط للتغيير، عمر أكثر من 5 سنوات = راجع فنياً، انتفاخ أو شق جانبي = غيّر فوراً. ونحن نستطيع فحص إطاراتك في بيتك قبل أن تقرر — أرسل لنا طلب فحص عبر واتساب.",
  },
  {
    slug: "كيف-اختار-مقاس-الكفر",
    title: "كيف أختار مقاس الكفر؟",
    excerpt: "المقاس الصحيح مكتوب على سيارتك بالفعل — تعلم قراءته واختيار الكفر المناسب دون تجربة وخطأ.",
    image: IMG.tireWheel,
    alt: "قراءة مقاس الكفر المكتوب على جانب الإطار",
    date: "2025-12-28",
    readTime: "5 دقائق",
    sections: [
      {
        h2: "المصدر الموثوق: ملصق باب السائق",
        body: "أدق مصدر لمقاس كفرات سيارتك ليس الكفر نفسه بل الملصق اللاصق داخل إطار باب السائق (أو دليل المالك). هذا الملصق يحدد مقاس الكفر وضغط الهواء الصحيح للأمامي والخلفي — وهي أرقام المواصفات التي صُنعت عليها السيارة.",
      },
      {
        h2: "اقرأ رمز المقاس خطوة بخطوة",
        body: "خذ المثال الشائع 205/55R16: الرقم 205 هو عرض الكفر بالمليمتر. الرقم 55 هو نسبة الجدار الجانبي (ارتفاع الجدار = 55% من العرض). حرف R يعني بناء شعاعي (Radial) وهو النمط السائد اليوم. الرقم 16 هو قطر الجنط بالبوصة — أي أن مقاس 16 يعني جنطاً 16 بوصة لا غير.",
      },
      {
        h2: "مؤشر الحمولة ورمز السرعة",
        body: "بعد المقاس يأتي رمزان مثل 91V: الرقم 91 هو مؤشر الحمولة (الوزن الأقصى للكفر الواحد — كل رقم يقابل قيمة بالكيلوجرام)، والحرف V هو رمز السرعة (السرعة القصوى التي صُمم الكفر لتحملها). لا تنزل عن مؤشر حمولة سيارتك، والالتزام برمز السرعة الموصى به هو الأصل.",
      },
      {
        h2: "هل أستطيع تغيير المقاس؟",
        body: "يوجد هامش محدود لتغيير المقاس (مثل الانتقال إلى جنط أكبر مع جدار جانبي أقل للحفاظ على القطر الكلي للعجلة). القاعدة: القطر الكلي للعجلة (الجنط + الكفر) يجب أن يبقى قريباً جداً من القطر الأصلي حتى لا تتأثر عداد السرعة وناقل الحركة والتعليق. إن فكرت في مقاس مختلف، استشر فنياً قبل الشراء — وسنحسب لك التوافق بدقة.",
      },
      {
        h2: "أخطاء شائعة تجنبها",
        body: "لا تشترِ على الشكل فقط، ولا تفترض أن كل كفرات السيارات المتشابهة في الحجم واحدة. المقاس الخاطئ يعني اهتزازاً أو احتكاكاً داخل قوس العجلة أو خطأ في قراءة السرعة. وإذا احرت بين مقاسين، فالأقرب إلى المواصفة الأصلية هو القرار الأسلم دائماً.",
      },
    ],
    conclusion: "احفظ هذه القاعدة: باب السائق أولاً، ثم قراءة الرمز بدقة، ثم مطابقة مؤشر الحمولة ورمز السرعة. وأي استفسار عن مقاسك — أرسل صورة الملصق أو الكفر لنا على واتساب وسنحدده لك فوراً.",
  },
  {
    slug: "ما-معنى-رموز-الكفرات",
    title: "ما معنى رموز الكفرات؟",
    excerpt: "حروف وأرقام على جانب كل كفر تحمل معلومات حاسمة — تعلم قراءة رموز الإطار مثل فني محترف.",
    image: IMG.shelf,
    alt: "رموز جانب الكفر التي تحمل مواصفات الإطار",
    date: "2026-01-02",
    readTime: "5 دقائق",
    sections: [
      {
        h2: "رمز المقاس: 225/45R18",
        body: "هذا أهم رمز على الكفر: 225 عرض الكفر بالمليمتر، 45 نسبة ارتفاع الجدار الجانبي إلى العرض، وR بناء شعاعي، و18 قطر الجنط بالبوصة. من هذه الأرقام تعرف فوراً إن كان الكفر مطابقاً لسيارتك قبل أي شيء آخر.",
      },
      {
        h2: "مؤشر الحمولة (Load Index)",
        body: "الرقم الذي يلي المقاس (مثل 91 في 205/55R16 91V) هو مؤشر الحمولة: كل رقم يقابل أقصى وزن يتحمله الكفر الواحد. مثلاً 91 يعني حوالي 615 كجم للكفر. إجمالي حمولة سيارتك موزعة على أربعة كفرات — فلا تنزل عن مؤشر حمولة سيارتك الأصلي.",
      },
      {
        h2: "رمز السرعة (Speed Rating)",
        body: "الحرف الأخير (مثل V) هو أقصى سرعة صُمم الكفر لتحملها بشكل مستمر. T تدل على حتى 190 كم/س، H حتى 210، V حتى 240، W حتى 270، وY حتى 300. السيارات الرياضية والفخمة تحتاج رموزاً أعلى. عند الاستبدال، الالتزام برمز سرعة المصنع أو أعلى منه هو القاعدة الصحيحة.",
      },
      {
        h2: "تاريخ الصناعة: رمز DOT",
        body: "على جانب الكفر ستجد سلسلة تبدأ بـ DOT تنتهي بأربعة أرقام: أول رقمين أسبوع الصناعة وآخر رقمين السنة. مثلاً 3524 يعني الأسبوع 35 من سنة 2024. هذا الرمز أهم أداة للتأكد من أن الإطار الذي تشتريه حديث الصناعة — ولمعرفة عمر إطاراتك الحالية.",
      },
      {
        h2: "رموز أخرى قد تقابلها",
        body: "M+S تعني ملاءمة الطين والثلج (لا تعني كفر ثلجي كامل)، علامة الاعتماد E تعني مطابقة للمعايير الأوروبية، وهناك علامات داخلي/خارجي (Inside/Outside) لاتجاه تركيب الكفر على الجنط، واتجاه الدوران (Rotation) على الكفرات الاتجاهية — تركيبها معاكساً لاتجاه دورانها يقلل تماسكها في المطر.",
      },
    ],
    conclusion: "قراءة الكفر مهارة بسيطة تحميك من شراء إطار غير مناسب: المقاس، الحمولة، السرعة، تاريخ الصناعة — أربعة رموز تكفي. وأي كفر نركبه لك ستجد مواصفاته مكتوبة بوضوح، ويشرحها لك الفني قبل التركيب.",
  },
  {
    slug: "ما-هو-TPMS",
    title: "ما هو TPMS؟ نظام مراقبة ضغط الكفرات",
    excerpt: "حساسات صغيرة داخل عجلاتك تراقب ضغط الكفرات لحظياً — تعرف كيف تعمل ومتى تحتاج صيانة أو برمجة.",
    image: IMG.grayRim,
    alt: "حساس ضغط الكفرات TPMS على عجلة السيارة",
    date: "2026-01-06",
    readTime: "4 دقائق",
    sections: [
      {
        h2: "التعريف البسيط",
        body: "TPMS اختصار لـ Tire Pressure Monitoring System، أي نظام مراقبة ضغط الكفرات. حساس صغير مثبت داخل كل عجلة يقيس ضغط الهواء في الكفر ويرسل القيمة إلى كمبيوتر السيارة، الذي يعرضها على الشاشة ويضيء تحذيراً على لوحة العدادات إذا انخفض الضغط عن الحد الآمن.",
      },
      {
        h2: "لماذا هو مهم؟",
        body: "الكفر المنخفض الضغط يسخن أكثر، يتآكل أسرع من الأطراف، ويزيد استهلاك الوقود، وأخطر من ذلك أنه يفقد جزءاً من قدرته على تحمل الأحمال — خاصة في أجواء الرياض الحارة. TPMS يحوّل هذه المشكلة إلى إشعار مبكر يظهر قبل أن تتحول إلى عطل على الطريق.",
      },
      {
        h2: "نوعان من الأنظمة",
        body: "النظام المباشر (Direct): حساس فعلي داخل كل عجلة يعرض ضغط كل كفر على حدة — أدق، ويحتاج بطارية داخل الحساس. النظام غير المباشر (Indirect): لا حساسات، بل يعتمد على دوران العجلات عبر نظام ABS — إذا انخفض ضغط كفر فقطره الفعلي يتغير فيتغير معدل دورانه فيكتشفه النظام. لكل نوع طريقة صيانة مختلفة.",
      },
      {
        h2: "متى يحتاج النظام إلى خدمة؟",
        body: "أبرز الحالات: ظهور لمبة التحذير مع ضغط صحيح (حساس معطل أو بطارية انتهت)، بعد تركيب كفرات جديدة أو تبديل مواقع الكفرات (يحتاج النظام إعادة تسجيل)، وبعد تركيب حساس جديد يحتاج برمجة بالمعرف الصحيح. خدمة برمجة TPMS المتنقلة لدينا تنفذ كل ذلك في موقعك.",
      },
      {
        h2: "نصائح للحفاظ على النظام",
        body: "اضبط الضغط الصحيح دائماً وفق ملصق الباب — لا وفق الرقم الأقصى المكتوب على الكفر. عند تغيير الكفرات اطلب فحص الحساسات قبل التركيب. وإذا تلف صمام الهواء أثناء فك الكفر (وهو جزء من مجمع الحساس في كثير من السيارات) فاستبدله فوراً ولا تؤجل الأمر.",
      },
    ],
    conclusion: "TPMS جهاز أمان صغير يحميك من أخطر مشاكل الكفرات قبل حدوثها. إذا ظهرت لمبة التحذير على سيارتك — راسلنا على واتساب وسيأتي فني مجهز بأجهزة القراءة والبرمجة إلى موقعك ويعالج الحالة في المكان نفسه.",
  },
  {
    slug: "لماذا-تظهر-لمبة-حساس-الكفر",
    title: "لماذا تظهر لمبة حساس الكفر؟",
    excerpt: "لمبة TPMS تضيء لأسباب مختلفة — من نقص ضغط حقيقي إلى حساس انتهت بطاريته. إليك كيف تشخّص السبب.",
    image: IMG.hero,
    alt: "لمبة تحذير حساس الكفر على لوحة عدادات السيارة",
    date: "2026-01-09",
    readTime: "4 دقائق",
    sections: [
      {
        h2: "السبب الأول: نقص ضغط حقيقي",
        body: "هذا هو السبب الأكثر شيوعاً والأسهل حلاً: كفر فقد جزءاً من هوائه. افحص الضغط في كل الكفرات (وليس الكفر المشتبه به فقط) بمقياس هواء. إن وجدت فرقاً ملحوظاً، عبّئ الضغط الصحيح وراقب: إذا عاد النقصان خلال أيام فهناك تسريب يحتاج إصلاحاً — وأغلب التسريبات تُغلق ميدانياً دون فك الجنط من السيارة.",
      },
      {
        h2: "السبب الثاني: تغيّر درجة الحرارة",
        body: "الهواء يتقلص مع البرودة ويتمدد مع الحرارة، فانخفاض درجات الليل قد يُنزل الضغط بمقدار ملموس ويُضيء اللمبة صباحاً ثم تنطفئ بعد القيادة. هذا طبيعي، لكنه تذكير بفحص الضغط مع تغير الفصول — فالضبط الصحيح يحل اللمبة فوراً.",
      },
      {
        h2: "السبب الثالث: مشكلة في الحساس نفسه",
        body: "إذا كان الضغط صحيحاً واللمبة مستمرة، فالحساس هو المشتبه به: بطاريته انتهت (تمشي سنوات طويلة ثم تتوقف)، أو تلف جسمه، أو فقد النظام تسجيله بعد فك وتركيب الكفرات. هنا تحتاج إلى جهاز قراءة TPMS لمعرفة أي عجلة لا ترسل — وهذا أول ما يفعله فنيّنا عند وصوله.",
      },
      {
        h2: "ماذا تفعل عملياً؟",
        body: "خطوات سريعة: افحص الكفرات بصرياً أولاً (كفر مسطح واضح يحتاج تدخلاً فورياً)، ثم اضبط الضغط على قيم الملصق وقُد مسافة قصيرة — بعض السيارات تحدّث اللمبة بعد مسافة. إذا بقيت اللمبة مضيئة أو وامضة فاراسلنا على واتساب: سنقرأ الحساسات في موقعك ونعرف إن كانت المشكلة ضغطاً أو حساساً — ونحلها في المكان نفسه.",
      },
    ],
    conclusion: "لمبة حساس الكفر ليست عيباً تتجاهله — إنها معلومة تنتظر تشخيصاً. نقص ضغط حقيقي نصلحه، حساس تالف نستبدله ونبرمجه، وكلاهما في موقعك دون رحلة ورشة.",
  },
  {
    slug: "متي-احتاج-الي-ترصيص",
    title: "متى أحتاج إلى ترصيص الإطارات؟",
    excerpt: "اهتزاز المقود والحفرة المفاجئة وعجلة غير متوازنة — متى يكون الترصيص هو الحل ومتى تكون المشكلة أعمق؟",
    image: IMG.pile,
    alt: "إطارات بحاجة إلى ترصيص على جهاز الموازنة",
    date: "2026-01-12",
    readTime: "4 دقائق",
    sections: [
      {
        h2: "ما هو الترصيص أصلاً؟",
        body: "الترصيص (الموازنة) هو توزيع وزن العجلة (الجنط + الكفر) توزيعاً متساوياً حول محور دورانها. آلة الموازنة تقيس أماكن الثقل الزائد بدقة، ويُضاف وزن صغير (الرصاص) في الموضع المناسب حتى تصبح العجلة متوازنة تماماً. اختلاف بضعة غرامات في العجلة يظهر كاهتزاز واضح بسرعات عالية — فالموازنة ليست رفاهية.",
      },
      {
        h2: "علامات تخبرك أنك تحتاج ترصيصاً",
        body: "أهم العلامات: اهتزاز في المقود أو جسم السيارة بسرعات محددة (عادة بين 80 و120 كم/س)، صوت طنين أو رفرفة من أحد الكفرات، تآكل غير متساوٍ ظهر على الكفر، أو صواميل ربط تعتق مع الوقت بسبب حركة العجلة غير المستقرة.",
      },
      {
        h2: "الحالات التي تستوجب الترصيص مباشرة",
        body: "بعد أي تركيب كفرات جديدة (لا استثناء)، بعد إصلاح بنشر (الإصلاح يضيف وزناً)، بعد المرور بحفرة عميقة أو اصطدام بحافة الرصيف (قد ينتقل الرصاص أو يتحرك الكفر على الجنط)، وعند تكرار الشكوى من اهتزاز بعد فترة طويلة من آخر موازنة — فالأوزان اللاصقة قد تسقط مع الغسالات ودرجات الحرارة.",
      },
      {
        h2: "الترصيص مقابل ضبط الزوايا",
        body: "الخلط بينهما شائع: الترصيص يعالج اهتزاز العجلة نفسها (وزن العجلة)، بينما ضبط الزوايا (المحاذاة) يعالج اتجاه العجلات ودرجات ميلها — وهو ما يسبب سحباً في المقود أو تآكلاً جانبياً على الكفر. إذا كان مقودك يسحب جهة أو يتآكل الكفر من جهة واحدة فالمشكلة زوايا تحتاج ضبطاً في مركز متخصص. أما الاهتزاز بسرعات ثابتة فغالباً ترصيص — وهو ما ننجزه في موقعك.",
      },
    ],
    conclusion: "القاعدة العملية: اهتزاز بسرعات ثابتة = ابدأ بالترصيص، فهو أسرع حل وأقل كلفة، وسنخبرك بصراحة إذا اتضح أن المشكلة أعمق من ذلك. اطلب خدمة الترصيص المتنقلة وسنصل إلى موقعك بالمعدات الكاملة.",
  },
  {
    slug: "كيف-اختار-الجنط-المناسب",
    title: "كيف أختار الجنط المناسب لسيارتك؟",
    excerpt: "القطر والعرض وخلوص البراغي والإزاحة — أربعة قياسات تحدد الجنط الصحيح، وتجنبك شراء جنط لن يركب أصلاً.",
    image: IMG.rimRed,
    alt: "جنط رياضي أسود على سيارة مع مكابح حمراء",
    date: "2026-01-15",
    readTime: "5 دقائق",
    sections: [
      {
        h2: "ابدأ من القياسات لا من الشكل",
        body: "الجنط الجميل الخطأ لن يفيدك بشيء. قبل التصميم واللون، تأكد من أربعة قياسات: القطر (16، 17، 18 بوصة...)، عرض الجنط، خلوص البراغي PCD (مثل 5x114.3 يعني خمس براغي على دائرة قطرها 114.3 ملم)، والإزاحة Offset التي تحدد مدى بروز الجنط للخارج أو داخله. هذه الأرقام محددة لكل سيارة، وخطؤها يعني إما عدم التركيب أو مشاكل في الاحتكاك والتعليق.",
      },
      {
        h2: "العلاقة بين الجنط والكفر",
        body: "لكل قطر جنط مقاسات كفرات مناسبة له. عند الانتقال إلى جنط أكبر (مثلاً من 17 إلى 18)، يقل ارتفاع الجدار الجانبي للكفر للحفاظ على القطر الكلي للعجلة — وهذا يمنح استجابة أدق للمقود لكنه يقلل امتصاص المطبات. جنط أصغر مع جدار أعلى يعطي راحة أعلى وقدرة أفضل على تحمل المفاجآت. اختر حسب أولويتك: مظهر رياضي أم راحة يومية.",
      },
      {
        h2: "الجودة والحمولة",
        body: "الجنط يحمل وزن السيارة فعلياً، فمؤشر الحمولة على الجنط يجب أن يغطي وزن سيارتك وأحمالها. جنوط الجودة تُصنع بسبك أو تقنية كور بمعايير محددة وتتحمل الاختبارات — أما الجنوط غير الموثوقة فمخاطرها تظهر عند المفاجآت: تشقق أو ارتداد في حافة الجنط بعد حفرة. وعنصر الأمان لا يُجامل فيه.",
      },
      {
        h2: "خطوات عملية قبل الشراء",
        body: "أولاً: حدد مقاس كفرك الحالي ونوع سيارتك وسنة موديلها. ثانياً: أرسلها لنا على واتساب — سنقترح جنوطاً متوافقة فعلاً بمقاسات من 16 إلى 19 بوصة. ثالثاً: عند التركيب نوازن كل عجلة ونربط بحساب العزم الصحيح، ونتأكد معك من عدم وجود احتكاك مع الكالبرات بعد مسافة قصيرة من القيادة.",
      },
    ],
    conclusion: "الجنط الصحيح يوازن بين ثلاثة: توافق ميكانيكي دقيق، جودة صناعة موثوقة، وشكل يليق بسيارتك. ونختار لك ما يتوافق مع سيارتك فعلاً — ونركبه في موقعك مع الموازنة الكاملة.",
  },
  {
    slug: "ماذا-افعل-اذا-انفجر-الكفر-علي-الطريق",
    title: "ماذا أفعل إذا انفجر الكفر على الطريق؟",
    excerpt: "ثوانٍ حاسمة تحدد سلامتك — تصرفات صحيحة عند انفجار الكفر أثناء السرعة، وكيف تستعيد السيطرة بأمان.",
    image: IMG.roadside,
    alt: "سيارة متوقفة على حافة الطريق بعد انفجار كفر",
    date: "2026-01-18",
    readTime: "4 دقائق",
    sections: [
      {
        h2: "في الثواني الأولى: ثبّت ولا تذعر",
        body: "عند انفجار الكفر بسرعة، ستشعر بسحبة قوية نحو الجهة المتضررة وصوت انفجار. التصرف الأخطر هنا هو التفاعل الخاطئ: لا تضغط الفرامل بقوة ولا تحرك المقود بحركة حادة. أمسك المقود بقبضة ثابتة، وصاد اتجاه السحبة بحركة لطيفة ومستقرة، وارفع قدمك عن الوقود تدريجياً. السيارة ستبطئ من نفسها بفعل مقاومة الكفر الممزق.",
      },
      {
        h2: "اخرج من حركة المرور بأمان",
        body: "مع انخفاض السرعة، وجّه السيارة بلطف إلى أقرب منطقة آمنة: حاف الطريق الأيمن، منطقة توقف الطوارئ، أو أقرب مخرج. لا تتوقف في منتصف المسار حتى لو بدت المشكلة مستعجلة — المكان الآمن أهم من السرعة. عند التوقف شغّل أضواء الطوارئ فوراً.",
      },
      {
        h2: "بعد التوقف: أمانك أولاً",
        body: "انزل من الجهة الآمنة (جهة الرصيف) وارتدِ سترة السلامة إن توفرت. لا تحاول تغيير الكفر على حافة المسار السريع — فهذه أخطر مكان ممكن لعمل يديك. في الطريق السريع: ابتعد عن السيارة خلف الحاجز واطلب الخدمة المتنقلة. وفي الشوارع الداخلية الأقل سرعة، إذا كان المكان آمناً وواسعاً فيمكن تغيير الكفر في الموقع.",
      },
      {
        h2: "متى تستدعي خدمة البنشر المتنقل؟",
        body: "في هذه الحالات أنت بحاجة إلى الفني لا إلى محاولتك الشخصية: انفجار على طريق سريع أو مكان ضيق أو إضاءة ضعيفة، عدم توفر كفر احتياطي أو انتهاء صلاحيته، أو إذا كانت الأدوات غير موجودة. الفني يصل بمعدات رفع وإنارة وإصلاح — ويعالج الحالة بأمان تام في موقعك.",
      },
      {
        h2: "بعد الحادثة: افحص الباقي",
        body: "انفجار كفر واحد غالباً ما يترك أثراً على الجنط (تشوه في الحافة) وعلى الكفر المجاور من الحمل الزائد اللحظي. اطلب فحص الجنط والتأكد من حالة باقي الكفرات وضغطها — فالإطارات التي تحملت اللحظة نفسها قد عانت من الإجهاد ذاته.",
      },
    ],
    conclusion: "احفظ التسلسل: ثبات على المقود، رفع قدم عن الوقود، توجيه لطيف، خروج آمن، أضواء طوارئ، ثم تواصل معنا عبر واتساب. واحتفظ برقمنا في هاتفك — خدمة البنشر المتنقل 24 ساعة في الرياض ستكون على بعد رسالة واتساب واحدة أينما كنت.",
  },
];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);
